import { TVehiculeCheckSchema } from '@/schemas/vehicule-check/vehicule-check.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import {
  AllToModerateVehiculeCheck,
  AllToValidateVehiculeCheck,
  TotalActiveVehiculeCheck,
} from '../entities/vehicule-check';
import { HistoryAdvancedFilter } from '@/entities/history';

const VEHICULE_CHECK_URI = '/vehiculeCheck';

export const createNewVehiculeCheck = async (
  vehicule: TVehiculeCheckSchema,
) => {
  return requestApi({
    url: VEHICULE_CHECK_URI,
    method: HTTP_METHOD.POST,
    body: vehicule,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingVehiculeCheck = async (
  query?: TVehiculeCheckSchema,
) => {
  let url = `${VEHICULE_CHECK_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.referenceNumber) {
    params.append('referenceNumber', query.referenceNumber);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// export const getAllVehiculeChecks = async (
//   filter: VehiculeCheckFilterType,
//   page: number,
//   limit: number,
//   sortBy?: string,
//   sortDirection?: 'asc' | 'desc'
// ) => {
//   let url = `${VEHICULE_CHECK_URI}/get/all?${mapVehicleFilterAPI(
//     filter
//   )}&page=${page}&limit=${limit}`;

//   // Add sort parameters if provided
//   if (sortBy) {
//     url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
//   }

//   return requestApi({
//     url,
//     method: HTTP_METHOD.GET,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
// };

export const getAllVehiculeChecks = async (
  filter: HistoryAdvancedFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const params = new URLSearchParams();

  params.append('filter', JSON.stringify(filter));
  params.append('page', String(page));
  params.append('limit', String(limit));
  params.append('sortBy', String(sortBy || ''));
  params.append('sortDirection', String(sortDirection));

  return requestApi({
    url: `${VEHICULE_CHECK_URI}/get/all?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveVehiculeChecks = async (
  query?: TotalActiveVehiculeCheck,
) => {
  let url = `${VEHICULE_CHECK_URI}/totalActive`;
  const params = new URLSearchParams();

  if (query?.vehiculeId) {
    params.append('vehiculeId', query?.vehiculeId);
  }

  if (query?.actionUserId) {
    params.append('actionUserId', query?.actionUserId);
  }

  if (query?.userId) {
    params.append('userId', query?.userId);
  }

  if (query?.onlyCompleted) {
    params.append('onlyCompleted', JSON.stringify(query?.onlyCompleted));
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getVehiculeCheckById = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/get/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksByActionUserId = async (
  actionUserId: string,
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/actionUser/${actionUserId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getCreatedVehiculeChecksPerMonth = async (userId?: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/stats/createdPerMonth${
      userId ? `?userId=${userId}` : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksToModerate = async (
  query?: AllToModerateVehiculeCheck,
) => {
  let url = `${VEHICULE_CHECK_URI}/get/all/toModerate`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query?.userId);
  }

  if (query?.actionUserType) {
    params.append('actionUserType', query?.actionUserType);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksToValidate = async (
  query?: AllToValidateVehiculeCheck,
) => {
  let url = `${VEHICULE_CHECK_URI}/get/all/toValidate`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (query?.actionUserType) {
    params.append('actionUserType', query.actionUserType);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehiculeCheck = async (
  vehiculeCheck: TVehiculeCheckSchema,
) => {
  const params = new URLSearchParams();

  if (vehiculeCheck?.updatingRequest) {
    params.append(
      'updatingRequest',
      vehiculeCheck?.updatingRequest?.toString(),
    );
  }

  delete vehiculeCheck?.updatingRequest;

  return requestApi({
    url: `${VEHICULE_CHECK_URI}/update?${params.toString()}`,
    method: HTTP_METHOD.PATCH,
    body: vehiculeCheck,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateModeration = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/validate-moderation/${id}`,
    method: HTTP_METHOD.PATCH,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteVehiculeCheck = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/delete/${id}`,
    method: HTTP_METHOD.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteManyVehiculeChecks = async (ids: string[]) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/deleteMany`,
    method: HTTP_METHOD.DELETE,
    body: ids,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
